module.exports = __webpack_public_path__ + "static/media/asu-logo.ea69bfe3.png";